'use es6';

var _window;
import { startInpage } from './start';

// If there is a custom inpage config on the window, use it
startInpage((_window = window) === null || _window === void 0 || (_window = _window.hubspot) === null || _window === void 0 ? void 0 : _window.InpageEditorConfig);